import type {Nullish} from 'shared/web';

import {smtpCredentialsTestStatus} from '../constants/smtpCredentialsTestStatus';
import {smtpCredentialsTestType} from '../constants/smtpCredentialsTestType';
import type {SmtpCredentialsTestRun} from '../types/SmtpCredentialsTestRun';
import type {SmtpTestChecklistRow} from '../types/SmtpTestChecklistRow';
import {isSmtpTestResultStatus} from './isSmtpTestResultStatus';

export function getSmtpTestChecklistRows(
  tests: SmtpCredentialsTestRun['tests'] | Nullish,
  isRunning: boolean
): SmtpTestChecklistRow[] {
  const checks = tests ?? [];
  if (isRunning && checks.length === 0) {
    return [{isActive: true, type: smtpCredentialsTestType.connection}];
  }

  const active = isRunning
    ? (checks.find((test) => test.status === smtpCredentialsTestStatus.inProgress) ??
      checks.find((test) => test.status === smtpCredentialsTestStatus.todo))
    : undefined;

  return checks.flatMap<SmtpTestChecklistRow>((test) => {
    if (isSmtpTestResultStatus(test.status)) {
      return [{isActive: false, type: test.type, status: test.status, reason: test.reason}];
    }
    return test === active ? [{isActive: true, type: test.type}] : [];
  });
}
